
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { Search, Refresh, Clear, RemoveCircle, AddCircleOutlineOutlined, ManageSearch } from "@mui/icons-material";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import { useGetTimberTypeQuery, useGetTimberTypeListQuery, useGetTimberTypePresentationQuery } from "../../../../timber/apis/TimberType.api";
import { TimberTypeNameDisplay, default as TimberTypeName } from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import { toString as toStringTimberType, PrimaryTimberType } from "../../../../timber/types/models/TimberType";

import { useGetTimberStorageQuery, useGetTimberStorageListQuery, useGetTimberStoragePresentationQuery } from "../../../../timber/apis/TimberStorage.api";
import { TimberStorageNameDisplay, default as TimberStorageName } from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageName";
import { toString as toStringTimberStorage, PrimaryTimberStorage } from "../../../../timber/types/models/TimberStorage";
import React from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Container,
    Stack,
    Button,
    FormControl,
    Divider,
} from "@mui/material";

import { object, string, number, boolean, date, coerce, TypeOf, array } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import * as crudgen from "../../../../share";
import {formatDateTime, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import {useDebounce} from "react-use";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useDispatch} from "react-redux";
import useSearch from "../../../../hooks/useSearch";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";

export const initialFormStateFn = () => { return {
    
    
        timberTypeId: [],
        
    
    
} }

export const formObject = {
    
            
            volumeFrom: coerce.number()
            .nullish(),
            volumeTo: coerce.number()
            .nullish(),
            
        
        
    
        timberTypeId: array(string()
            .nullish()),
        
        
    
        storageId: string()
            .nullish(),
        
        
    
};

export const formSchema = object(formObject);

export type FormInput = TypeOf<typeof formSchema>;

type IProps = {
    prefix?: string;
    setSearchInputValue: (search: string) => void;
    searchInputAdvanced: any;
    setSearchInputAdvanced: (any) => void;
    query: any;
    refetch: () => void;
}

const TreeMarkingListSearch = (props: IProps) => {
    
    const {advancedSearch, search, updateSearch} = useSearch('TreeMarking')
    
    const [advanced, setAdvanced] = React.useState(advancedSearch);
    
    const {prefix = '', query} = props;
    
    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: advanced ? search : initialFormStateFn()
    });

    const {
        reset,
        watch,
        handleSubmit,
        formState: { isSubmitSuccessful },
    } = methods;
    
    
    const { data: timberTypeList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getTimberTypeListLoading,
        isFetching: getTimberTypeListFetching, 
    } = useGetTimberTypeListQuery()
    
    
    const [, setTimberStorageInputValue, timberStorageInputTerm] = useSearchDebounce();
    const { data: timberStorageList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getTimberStorageListLoading,
        isFetching: getTimberStorageListFetching, 
    } = useGetTimberStoragePresentationQuery({
        list: {
            page: 0,
            pageSize: 12,
        },
        filter: {
            name: timberStorageInputTerm || '',
                    nameOr: true,
                    },
    })
    
    
    
    const cancelSearch = React.useCallback((e: any) => {
        e.stopPropagation()
        props.setSearchInputAdvanced(undefined)
        setAdvanced(false)
    })
    
    const onAdvancedSubmitHandler: SubmitHandler<FormInput> = (values, e: any) => {
        props.setSearchInputAdvanced(values)
    };

    

    React.useEffect(() => {
        if (!advancedSearch) {
            props.setSearchInputValue(search)
        }
    }, []);

    const [advancedFormValues, setAdvancedFormValues] = React.useState(advanced ? search : initialFormStateFn())

    const [, cancelAdvancedFormValues] = useDebounce(() => {
        if (advanced) {
            handleSubmit(onAdvancedSubmitHandler)()
            updateSearch(advanced, advancedFormValues)
        }
    }, DEBOUNCE_TIME, [advancedFormValues, advanced])

    React.useEffect(() => {
        const subscription = watch((values) => {
            setAdvancedFormValues(values)
        });
        return () => {
            cancelAdvancedFormValues()
            subscription.unsubscribe()
        }
    }, [watch, cancelAdvancedFormValues]);
        
    if (!advanced)
    return (<Box
        component="form"
        onSubmit={(e) => {e?.preventDefault()}}
        noValidate
        sx={ { '& > :not(style)': { m: 1, width: '100%', padding: '1em' } } }
        autoComplete="off"
        data-testid="TreeMarking-search-form"
    >
        <TextField
            defaultValue={ !advancedSearch ? search : '' }
            label={t`Search (by Timber Type, Volume (m&#xB3;))`}
            onChange={ (event) => {
                props.setSearchInputValue(event.target.value)
                updateSearch(false, event.target.value)
            } }
            variant="standard"
            slotProps={ {
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    props.setSearchInputValue('')
                                    updateSearch(false, '')
                                } }
                                edge="end"
                            >
                                <Clear />
                            </IconButton>
                            <IconButton
                                onClick={() => setAdvanced(!advanced)}
                                edge="end"
                            >
                                <ManageSearch />
                            </IconButton>
                            
                            <IconButton
                                onClick={props.refetch}
                                edge="end"
                            >
                                <Refresh />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            } }
        />
    </Box>)
    if (advanced)
        return (<Container sx={ { marginBottom: '1em' } }>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={handleSubmit(onAdvancedSubmitHandler)}
                    noValidate
                    data-testid="TreeMarking-advanced-search-form"
                >
                    <FormControl fullWidth size="small">
                        
        
            
            <Stack direction="row" spacing={1}>
                <crudgen.FormInput
                        name={ prefix + 'volumeFrom' }
                        label={t`Volume (m&#xB3;) From`}
                        clearable={true}
                        
                        type='number'
                        checkNumber={true}
                        forceNumber={true}
                        
                />
                <crudgen.FormInput
                        name={ prefix + 'volumeTo' }
                        label={t`Volume (m&#xB3;) To`}
                        clearable={true}
                        
                        type='number'
                        checkNumber={true}
                        forceNumber={true}
                        
                />
            </Stack>
            
        
    

                        
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'timberTypeId' }
                optionsLoading={ getTimberTypeListLoading || getTimberTypeListFetching }
                label={t`Timber Type`}
                options={ timberTypeList.items }
                valueMap={ (id) => useGetTimberTypeQuery(PrimaryTimberType.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringTimberType }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><TimberTypeNameDisplay data={option}/></li>)
                } }
                
                
                renderValue={(value, getItemProps) =>
                    value.map((option: any, index: number) => {
                        const { key: _key, ...tagProps } = getItemProps({ index })
                        return (
                            <crudgen.SelectChip key={index} {...tagProps}>
                                <TimberTypeName id={option}/>
                            </crudgen.SelectChip>
                        );
                    })
                }
                multiple
                
        />
        
    

                        
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'storageId' }
                optionsLoading={ getTimberStorageListLoading || getTimberStorageListFetching }
                label={t`Timber Storage`}
                options={ timberStorageList.items }
                valueMap={ (id) => useGetTimberStorageQuery(PrimaryTimberStorage.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringTimberStorage }
                onInputChange={ setTimberStorageInputValue }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><TimberStorageNameDisplay data={option}/></li>)
                } }
                
                
            
        />
        
    

                        
                        
                        <Stack direction="row" spacing={1}>
                            <Button size="small"  variant="outlined" color="primary" type='submit' sx={ {display: 'none'} }>
                                <Search /> <Trans>Search</Trans>
                            </Button>
                            <Button size="small"  variant="outlined" color="primary" onClick={props.refetch}>
                                <Refresh /> <Trans>Refresh</Trans>
                            </Button>
                            <Button size="small" variant="outlined" onClick={cancelSearch} color="inherit">
                                <Trans>Cancel</Trans>
                            </Button>
                        </Stack>
                    </FormControl>
                </Box>
            </FormProvider>
        </Container>)
    
}

export default TreeMarkingListSearch;
